/**
 * ChatChannelMemberData 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { ChatChannelData } from './chat_channel_data'
import type { ChatChannelMember } from './chat_channel_member'
import type { UserData } from './user_data'

/**
 * ChatChannelMemberData
 */
export interface ChatChannelMemberData {
  /** 成员记录ID */
  id?: string
  /** 成员基础信息 */
  info?: ChatChannelMember
  /** 用户信息 */
  user?: UserData
  /** 频道信息 */
  channel?: ChatChannelData
}

/**
 * ChatChannelMemberData Schema
 */
export const ChatChannelMemberDataSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '成员记录ID',
      format: 'string',
      type: 'string',
      label: '成员记录ID',
    },
    info: {
      $ref: 'ChatChannelMember',
      description: '成员基础信息',
      label: '成员基础信息',
    },
    user: {
      $ref: 'UserData',
      description: '用户信息',
      label: '用户信息',
    },
    channel: {
      $ref: 'ChatChannelData',
      description: '频道信息',
      label: '频道信息',
    },
  },
  type: 'object',
}
